export class FilterCommonAll {
    category: any
    filterOption: any;
    attribute: any;
    filterAttribute: any;
}